import { FC, useEffect } from 'react';

import RazorpayCommon from 'components/razorpay-common';
import { useAppDispatch, useAppSelector } from 'hooks';
import loadRazorpay, { RazorpayWrapper } from 'lib/razorpay-checkout';
import { accountKey, sessionId } from 'modules/global-wrapper';
import { sessionSuccessRedirectUrl, sesssionCancelRedirectUrl } from 'modules/session-details';
import {
  addRazorpayStep1Resp,
  addRazorpayStep2Resp,
  postTransactionAddRazorpayStep1,
  postTransactionAddRazorpayStep2,
} from 'modules/transaction-razorpay';

let RazorpayInstance: RazorpayWrapper | undefined = undefined;

const RazorpayMethod: FC = () => {
  const dispatch = useAppDispatch();

  const selectedAccountKey = useAppSelector(accountKey);

  const selectedSessionId = useAppSelector(sessionId);
  const selectedSuccessRedirectUrl = useAppSelector(sessionSuccessRedirectUrl);
  const selectedCancelRedirectUrl = useAppSelector(sesssionCancelRedirectUrl);

  const selectedAddRpStep1Resp = useAppSelector(addRazorpayStep1Resp);
  const selectedAddRpStep2Resp = useAppSelector(addRazorpayStep2Resp);

  const handlePaymentSuccess = (data) => dispatch(postTransactionAddRazorpayStep2(data));

  const handleModalClose = () => window.location.assign(selectedCancelRedirectUrl);

  useEffect(() => {
    if (selectedAccountKey && selectedSessionId) {
      RazorpayInstance = loadRazorpay();
      dispatch(postTransactionAddRazorpayStep1());
    }
  }, [dispatch, selectedAccountKey, selectedSessionId]);

  if (selectedAddRpStep2Resp.paymentMethodKey) {
    window.location.assign(selectedSuccessRedirectUrl);
  }

  return (
    <RazorpayCommon
      Razorpay={RazorpayInstance}
      step1Resp={selectedAddRpStep1Resp}
      handlePaymentSuccess={handlePaymentSuccess}
      handleModalClose={handleModalClose}
    />
  );
};

export default RazorpayMethod;
